import { Injectable } from '@angular/core';
import { Sample, SampleAudit } from '../types';
//import { Headers, Response, Http, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()

export class SampleService {
  private samplesUrl = 'api/samples';

  constructor(private http: HttpClient) { }

  getSamplesByRackId(id: Number): Observable<Sample[]> {
    const url = `api/racksamples/${id}`;
    return this.http.get<Sample[]>(url)
      //.map((res:Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getSamplesByBoxId(id: Number): Observable<Sample[]> {
    const url = `api/boxsamples/${id}`;
    return this.http.get<Sample[]>(url)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getSampleAudits(sampno: string): Observable<SampleAudit[]> {
    const url = `api/sampleaudit/${sampno}`;
    return this.http.get<SampleAudit[]>(url)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getBoxSampleAuditsByTrackingID(trackingId: string): Observable<SampleAudit[]> {
    const escapedId = encodeURIComponent(trackingId);
    const url = `api/boxsampleaudits/${escapedId}`;
    return this.http.get<SampleAudit[]>(url)
      //.map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }
  saveSample(samp: Sample): Observable<number> {
    return this.http.post<number>(this.samplesUrl, samp)
      //.map((res: Response) => 
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  queueSampleForPrint(sampid : number): Observable<any> {
    const url = `api/queuesample/${sampid}`;
    return this.http.post<any>(url, null)
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  destroySample(samp: Sample): Observable<any> {
    const url = `api/sample/${samp.SampleId}`;
    return this.http.delete<number>(url)
      //.map((res: Response) => +res.text())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  destroySampleById(sampid: number): Observable<any> {
    const url = `api/sample/${sampid}`;
    return this.http.delete<number>(url)
      //.map((res: Response) => +res.text())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  findIncomplete(samp: Sample): Observable<string[]> {
    const url = `api/incomplete/${samp.SampleNo}`;
    return this.http.get<string[]>(url)
      //.map((res: Response) => +res.text())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  postFile(fileToUpload: File): any {
    const endpoint = '/api/sampleauditlist';
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.http
      .post(endpoint, formData, { responseType: 'blob' as 'json', observe: 'response' as 'response' }).toPromise();
  }
}
